<i18n src="@/locales/modules/TodoListTranslate.json"></i18n>

<template>
	<div>
		<vs-dropdown vs-custom-content vs-trigger-hover class="cursor-pointer">
			<a class="flex items-center cursor-pointer" href.prevent>
				<i class="nucleo nucleo-sort text-xl cursor-pointer"></i>
			</a>

			<vs-dropdown-menu class="dropdown-sort-todo">
				<div class="dropdown-sort-todo--content">
					<ul class="">
						<li v-for="(sort, index) in sorts" :key="index">
							<vs-checkbox v-if="sort.column === 'created_at' && sort.direction === 'asc'" class="my-2 mx-3" v-model="form.sorts" :vs-value="sort">{{ $t("OldestTodos") }}</vs-checkbox>
							<vs-checkbox v-else class="my-2 mx-3" v-model="form.sorts" :vs-value="sort">{{ $t(`Sort.${sort.column}`) }}</vs-checkbox>
						</li>
					</ul>
				</div>
			</vs-dropdown-menu>
		</vs-dropdown>
	</div>
</template>

<script>
export default {
	name: "TodoSortContextMenu",
	data() {
		return {
			form: {
				sorts: []
			},
			sorts: [
				{ column: "created_at", direction: "asc" },
				{ column: "created_at", direction: "desc" },
				{ column: "deadline", direction: "desc" },
				{ column: "priority", direction: "desc" }
			]
		};
	},
	watch: {
		form: {
			handler: function() {
				this.$emit("onChangeSort", this.form.sorts);
			},
			deep: true
		}
	}
};
</script>
<style lang="scss">
.dropdown-sort-todo .dropdown-sort-todo--content {
	min-width: 14rem;
}
</style>
